export interface KeyboardListener {
	onKeyboardState(tracker: KeyboardTracker): void;
}

export class KeyboardTracker {
	private readonly downSet: Set<string> = new Set();
	private ctrlDown = false;
	private readonly listeners: KeyboardListener[] = [];

	constructor() {
		document.addEventListener('keydown', e => {
			this.downSet.add(e.code)
			this.ctrlDown = e.ctrlKey;
			this.fireListeners();
		});
		document.addEventListener('keyup', e => {
			this.downSet.delete(e.code)
			this.ctrlDown = e.ctrlKey;
			this.fireListeners();
		});
	}

	/**
	 * code is like 'KeyM'
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_code_values
	 * @param code
	 */
	isDown(code: string) {
		return this.downSet.has(code)
	}

	isCtrl() {
		return this.ctrlDown;
	}

	addListener(listener: KeyboardListener) {
		this.listeners.push(listener);
	}

	removeListener(listener: KeyboardListener) {
		const index = this.listeners.indexOf(listener);
		if (index >= 0) {
			this.listeners.splice(index, 1);
		}
	}

	private fireListeners() {
		const listeners = ([] as KeyboardListener[]).concat(this.listeners)
		listeners.forEach(l => l.onKeyboardState(this))
	}
}


let instance: KeyboardTracker = new KeyboardTracker()

export function getKeyboardTracker() {
	return instance;
}
